export const faqs = [
  {
    id: '1',
    question: '成91是什么平台？',
    answer: '成91是一个备受用户关注的热门综合服务平台，致力于为用户提供优质、便捷的在线服务体验。平台功能丰富，涵盖了多个领域的服务内容，是广大用户信赖的在线平台之一。'
  },
  {
    id: '2',
    question: '如何找到成91的最新官方入口？',
    answer: '成91官方入口会定期更新以确保平台安全稳定运行。建议您收藏本页面，我们将实时同步成91最新官方入口信息。您也可以通过成91官方认证的社交媒体渠道获取最新入口通知。'
  },
  {
    id: '3',
    question: '成91注册需要哪些条件？',
    answer: '成91的注册流程简单快捷。您只需准备好有效的手机号或邮箱，按照注册页面的指引填写基本信息并完成验证，即可成功注册成91账户。注册过程完全免费。'
  },
  {
    id: '4',
    question: '成91会员有什么权益？',
    answer: '成91会员享有丰富的专属权益，包括但不限于：优先客服响应、专属功能权限、活动优先参与权、积分加速获取等。不同会员等级对应不同的权益内容，等级越高权益越丰富。'
  },
  {
    id: '5',
    question: '忘记成91登录密码怎么办？',
    answer: '如果您忘记了成91的登录密码，请点击登录页面的"忘记密码"按钮，按照系统提示通过绑定的手机号或邮箱进行密码重置。重置完成后即可使用新密码登录。'
  },
  {
    id: '6',
    question: '成91是否安全可靠？',
    answer: '成91高度重视用户账户和数据安全，采用业界领先的安全技术保护用户信息。平台设有安全中心，提供多重安全防护措施，包括登录保护、异常提醒、数据加密等，全方位保障您的账户安全。'
  },
  {
    id: '7',
    question: '成91支持哪些设备访问？',
    answer: '成91支持多种设备访问，包括电脑端（Windows/Mac）、移动端（iOS/Android手机和平板）等多种平台。您可以根据自己的使用场景选择最便捷的设备访问成91。'
  },
  {
    id: '8',
    question: '遇到使用问题如何联系成91客服？',
    answer: '如您在使用成91过程中遇到任何问题，可以通过以下方式联系客服：通过平台内客服入口在线咨询、发送邮件至官方客服邮箱、查看帮助中心的使用教程和常见问题解答。成91客服团队将竭诚为您服务。'
  },
];